import { RefObject, useEffect } from "react";

export const usePinToTableScroll = (ref: RefObject<HTMLElement>) => {
  useEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }

    let scroller: HTMLElement | null = null;
    for (
      let node = element.parentElement;
      node;
      node = node.parentElement
    ) {
      if (node.classList.contains("MuiTableContainer-root")) {
        scroller = node;
      }
    }
    if (!scroller) {
      return;
    }

    const table = scroller;
    let frame = 0;
    const sync = () => {
      frame = 0;
      element.style.left = `${table.scrollLeft}px`;
    };
    const onScroll = () => {
      if (!frame) {
        frame = requestAnimationFrame(sync);
      }
    };

    // The element mounts at left: 0; align it with wherever the table sits now.
    sync();
    table.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      if (frame) {
        cancelAnimationFrame(frame);
      }
      table.removeEventListener("scroll", onScroll);
    };
  }, [ref]);
};
